<template>
  <div>
    <list row-key="RecordId" ref="list" unit="商品调价" :page="page" :query-params="params" :show-checkbox="$permission.canDel()"
      :show-query="showQuery" :get-data-func="api.list" @on-reset="onResetQuery">
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="模板名称">
          <el-input v-model="params.AdjustName" placeholder="请输入模板名称" clearable />
        </el-form-item>
        <el-form-item label="生效时间">
          <range-picker ref="picker" @change="(x) => {
            params.EffectTimeStart = x.Start;
            params.EffectTimeEnd = x.End;
          }" />
        </el-form-item>
        <el-form-item label="商品分类">
          <tree-select ref="treeSelect" :props="props" :options="Types" :value="params.TypeId" :label="params.TypeName" accordion filterable
            parentSelect placeholder="请选择分类" @node-select="onTreeSelect($event)" />
        </el-form-item>
        <el-form-item label="商品名称">
          <el-input v-model="params.GoodsName" placeholder="请输入商品名称" clearable />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="params.State" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="停用" :value="0"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="AdjustName" label="调价模板名称" min-width="120" />
        <el-table-column prop="EffectTime" label="调价生效时间" min-width="160">
          <template slot-scope="{row}">{{ row.EffectTime }}</template>
        </el-table-column>
        <el-table-column prop="TypeCount" label="涉及商品分类数量" min-width="140" />
        <el-table-column prop="GoodsCount" label="涉及商品数量" min-width="120" />
        <el-table-column prop="AddTime" label="调价日期" min-width="120">
          <template slot-scope="{row}">{{ $commonJs.toDateString(row.AddTime) }}</template>
        </el-table-column>
        <el-table-column prop="State" width="80px" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.State == 1">启用</el-tag>
            <el-tag type="danger" v-else>停用</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
  <script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/goods/adjustprice").default,
      typeApi: require("@/api/goods/type").default,
      params: {
        AdjustName: "",
        EffectTimeStart: null,
        EffectTimeEnd: null,
        GoodsName: "",
        TypeId: null,
        TypeName: "",
        TypeIdChain: "",
        State: null,
      },
      Types: [],
      props: {
        // 配置项（必选）
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },
  mounted() {
    this.typeApi.list({ State: 1 }).then(res => {
      this.Types = this.$commonJs.toTreeData(res.Data, "RecordId", "TypeIdParent");
    })
  },
  methods: {
    onTreeSelect(data) {
      console.log("data", data);
      if (data) {
        this.params.TypeIdChain = data.IdChain;
      } else {
        this.params.TypeIdChain = "";
      }
    },
    onResetQuery() {
      if (this.$refs.picker) this.$refs.picker.clear();
      if (this.$refs.treeSelect) this.$refs.treeSelect.clearHandle();
      console.log("onResetQuery", this.params)
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
  </script>